// extracted by mini-css-extract-plugin
module.exports = {"label":"RSTextArea_label__fkGww","textarea":"RSTextArea_textarea__2x8vw"};